module.exports = __webpack_public_path__ + "static/media/systray_304.58513254.ico";